import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "toastr/build/toastr.min.css";
import "react-date-range/dist/styles.css"; // custom-date-picker
import "react-date-range/dist/theme/default.css"; // custom-date-picker
import "rc-slider/assets/index.css";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import { getNotifications } from "./store/notifications/actions";
import { userInit } from "./store/actions";
import { getListByPermissions } from "./helpers/utils";
import TokenRefreshComponent from "./components/TokenRefreshComponent";
import { MetaTags } from "react-meta-tags";
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"
// import { getNotifications } from './store/notifications/actions';
// Import fackbackend Configuration file

// Activating fake backend
// fakeBackend()

// Activating fake firebase
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.userInit(this.props.history);
    window.push = this.props.history.push;
    this.props.isLogin && this.props.getNotifications();

  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log(this.props.location)
      // this.props.isLogin && this.props.getNotifications()
    }
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();
    return (
      <React.Fragment>
        {/*<Router>*/}
        {this.props.isLogin !== undefined && (
          <>
            <TokenRefreshComponent />
            <Switch>
              {!this.props.isLogin &&
                publicRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={NonAuthLayout}
                    component={route.component}
                    key={"idx_" + idx}
                    isAuthProtected={false}
                    exact={route.exact}
                    isLogin={this.props.isLogin}
                  />
                ))}

              {this.props.isLogin &&
                this.props.permissions &&
                getListByPermissions(
                  authProtectedRoutes,
                  this.props.permissions
                ).map((route, idx) => (
                  // {this.props.permissions && authProtectedRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={Layout}
                    component={route.component}
                    key={idx}
                    isUserLogin={this.props.isLogin}
                    permissions={this.props.permissions}
                    isAuthProtected={true}
                    exact={route.exact}
                    permission={route.permission}
                  />
                ))}

              {/*{(this.props.permissions || this.props.isLogin || localStorage.getItem("authUser")) && <Redirect to={'/dashboard'}/>}*/}
              {/*{!this.props.permissions && !this.props.isLogin && <Redirect to={'/login'}/>}*/}
              {/*{!this.props.permissions && !this.props.isLogin && <Route*/}
              {/*  path={"/"}*/}
              {/*  exact={false}*/}
              {/*>*/}
              {/*  <Redirect to={'/login'}/>*/}
              {/*</Route>}*/}
            </Switch>
          </>
        )}
        {/*</Router>*/}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    isLogin: state.User.isLogin,
    permissions: state.User.permissions,
  };
};

App.propTypes = {
  location: PropTypes.any,
  layout: PropTypes.object,
  isLogin: PropTypes.bool,
  userInit: PropTypes.func,
  history: PropTypes.object,
  permissions: PropTypes.any,
  getNotifications: PropTypes.func,
};

export default connect(mapStateToProps, { userInit, getNotifications })(
  withRouter(App)
);
